import { DateTimeParts } from '../../../types';
import { ISO_REGEXES } from './constants';
import { parse } from '../parseUnitInRange';

export const extractPartialIsoDateTime = (value: string): DateTimeParts | undefined => {
  const getMonth = (month: string) => (parse(month, 0, 12) > 0 ? parse(month, 0, 12) - 1 : -1);
  if (ISO_REGEXES.ISO_WITH_MILLISECOND.test(value)) {
    const match = ISO_REGEXES.ISO_WITH_MILLISECOND.exec(value);
    if (match) {
      const [year, month, day, hour, minute, second, millisecond] = match.slice(1);
      return {
        year: parse(year, 0, 9999),
        month: getMonth(month),
        day: parse(day, 1, 31),
        hours: parse(hour, 0, 60),
        minutes: parse(minute, 0, 60),
        seconds: parse(second, 0, 60),
        milliseconds: parse(millisecond, 0, 999),
      };
    }
  } else if (ISO_REGEXES.ISO_WITH_SECOND.test(value)) {
    const match = ISO_REGEXES.ISO_WITH_SECOND.exec(value);
    if (match) {
      const [year, month, day, hour, minute, second] = match.slice(1);
      return {
        year: parse(year, 0, 9999),
        month: getMonth(month),
        day: parse(day, 1, 31),
        hours: parse(hour, 0, 60),
        minutes: parse(minute, 0, 60),
        seconds: parse(second, 0, 60),
        milliseconds: 0,
      };
    }
  } else if (ISO_REGEXES.ISO_WITH_MINUTE.test(value)) {
    const match = ISO_REGEXES.ISO_WITH_MINUTE.exec(value);
    if (match) {
      const [year, month, day, hour, minute] = match.slice(1);
      return {
        year: parse(year, 0, 9999),
        month: getMonth(month),
        day: parse(day, 1, 31),
        hours: parse(hour, 0, 60),
        minutes: parse(minute, 0, 60),
        seconds: 0,
        milliseconds: 0,
      };
    }
  }
  return undefined;
};
